import { render, staticRenderFns } from "./YourProDetail.vue?vue&type=template&id=f5bd6ee4"
import script from "./YourProDetail.vue?vue&type=script&lang=js"
export * from "./YourProDetail.vue?vue&type=script&lang=js"
import style0 from "./YourProDetail.vue?vue&type=style&index=0&id=f5bd6ee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
